import { render, staticRenderFns } from "./workpackageSvg.vue?vue&type=template&id=8784004a&"
import script from "./workpackageSvg.vue?vue&type=script&lang=js&"
export * from "./workpackageSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports